import Image from './image';
import Benefit from '../Benefits/Benefit';
import React from 'react';
import styled from 'styled-components';
import {
  screenSmMin,
  screenLgMin,
  cssSpacing,
  Text,
  screenMdMin,
} from '@spotify-internal/encore-web';
import { SectionWrapper } from '../Shared/components';

export const BenefitsContent = styled.ul<{ verticalBenefits: boolean }>`
  padding: 0;
  margin: 0;
  list-style: none;

  ${({ verticalBenefits }) =>
    verticalBenefits &&
    `
    flex-direction: column;
  `}

  @media (min-width: ${screenSmMin}) {
    flex-wrap: wrap;
    display: flex;
  }

  @media (min-width: ${screenLgMin}) {
    flex-wrap: nowrap;
    ${({ verticalBenefits }) =>
      verticalBenefits &&
      `
    flex-direction: row;
  `}
  }

  > * {
    flex: 1 1 auto;
    min-width: 0;
  }
`;

type ImagePropTypes = {
  size: React.ComponentProps<typeof Benefit>['size'];
};
export const BenefitImage = styled(Image)<ImagePropTypes>`
  display: inline-block;
  background-position: center top;
  margin-right: 20px;
  flex-grow: 1;
  ${({ size }) => {
    switch (size) {
      default:
      case 'medium':
        return `
          width: 142px;
          height: 142px;`;
      case 'small':
        return `
           width: 60px;
           height: 60px;
        `;
      case 'skyscraper':
        return `
          width: 295px;
          height: 185px;
          @media (min-width: ${screenLgMin}) {
            height: 360px;
          }
        `;
    }
  }}
  @media (min-width: ${screenLgMin}) {
    display: block;
    margin: 0 auto 40px auto;
    ${({ size }) => {
      switch (size) {
        default:
        case 'medium':
          return `margin: 0 auto 40px auto;`;
        case 'small':
          return `margin: 0 auto 10px auto;`;
      }
    }}
  }
`;

export const BenefitContent = styled.div`
  display: inline-block;
  width: 100%;
  flex-grow: 1;
  margin: ${cssSpacing('base')} 0;
  @media (min-width: ${screenLgMin}) {
    display: block;
    text-align: center;
  }
`;

export const BenefitHeader = styled(Text)`
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 21px;
  padding: 0;
  line-height: 1.3em;
`;

export const StyledText = styled(Text)`
  line-height: 1.5;
  font-size: 16px;
  padding: 0;
  a {
    color: #000;
    text-decoration: underline;
  }
  @media (min-width: ${screenSmMin}) {
    width: 85%;
  }
  @media (min-width: ${screenLgMin}) {
    margin: 0 auto;
  }
`;

type WrapperPropTypes = {
  size: React.ComponentProps<typeof Benefit>['size'];
};

export const Wrapper = styled.li<WrapperPropTypes>`
  margin-bottom: 20px;
  display: flex;

  @media (min-width: ${screenSmMin}) {
    flex-grow: 1;
    width: 50%;
  }

  @media (min-width: ${screenLgMin}) {
    vertical-align: top;
    display: block;

    ${({ size }) => {
      switch (size) {
        default:
          return `
            width: 270px;
          `;
        case 'skyscraper':
          return `
            width: 295px;
          `;
      }
    }}
  }
`;

export const HeaderText = styled(Text)`
  text-align: center;
  margin-top: 32px;
  margin-bottom: 32px;
  @media (min-width: ${screenMdMin}) {
    margin-top: 72px;
    margin-bottom: 48px;
  }
`;

export const BenefitsContainer = styled(SectionWrapper)`
  min-height: auto;

  > article {
    padding: 0 23px ${cssSpacing('looser-3')};
  }
`;
